;(function() {
  'use strict'

  service.$inject = ["$transitions", "$state", "$stateParams", "glPrefs"];
  angular.module('core.services').factory('chainService', service)

  /* @ngInject */
  function service($transitions, $state, $stateParams, glPrefs) {
    var prefs = glPrefs.create('chainService')

    var shouldHold = false

    $transitions.onStart(null, checkHold)
    $transitions.onSuccess(null, updateState)

    init()

    return {
      hold: hold,
      reset: reset,
      update: update,
      get: get,
      header: header,
    }

    function init() {
      var chain = get()
      if (
        chain.stateName !== $state.current.name &&
        !_.isEqual(chain.stateParams, $stateParams)
      ) {
        reset()
      }
    }

    function checkHold() {
      var keep = !!shouldHold
      shouldHold = false
      if (!keep) {
        reset()
      }
    }

    function updateState() {
      var chain = get()
      chain.stateName = $state.current.name
      chain.stateParams = $stateParams
      prefs.set('chain', chain)
    }

    function hold() {
      shouldHold = true
    }

    function reset() {
      var chain = {}
      prefs.set('chain', chain)
      return chain
    }

    function update(data) {
      var chain = get()
      _.extend(chain, data)
      prefs.set('chain', chain)
      updateState()
    }

    function get() {
      return prefs.get('chain') || {}
    }

    function header() {
      var chain = get()
      var header = []
      if (chain.linkId) {
        header.push('link:' + chain.linkId)
      }
      if (chain.pageId) {
        header.push('page:' + chain.pageId)
      }
      if (chain.moduleId) {
        header.push('module:' + chain.moduleId)
      }
      if (chain.elementId) {
        header.push('element:' + chain.elementId)
      }
      if (chain.channelId) {
        header.push('channel:' + chain.channelId)
      }
      return header.length ? header.join(',') : null
    }
  }
})()
